import { Modal, InlineGrid, Card, BlockStack, Text, Button, Box } from '@shopify/polaris';

export const DeliveryAddressSelectModal = ({ open, onClose, defaultAddress, externalAddress, onSelectDefault, onSelectExternal }) => {
  const formatAddress = (addr) => {
    if (!addr) return null;
    const parts = [];
    if (addr.company) parts.push(addr.company);
    if (addr.department) parts.push(addr.department);
    if (addr.firstName || addr.lastName) parts.push(`${addr.firstName || ''} ${addr.lastName || ''}`.trim());
    if (addr.street) parts.push(addr.street);
    if (addr.zipcode || addr.city) parts.push(`${addr.zipcode || ''} ${addr.city || ''}`.trim());
    if (addr.country) parts.push(addr.country);
    return parts;
  };

  const defaultAddressParts = formatAddress(defaultAddress);
  const externalAddressParts = formatAddress(externalAddress);

  return (
    <Modal open={open} onClose={onClose} title="Select delivery address" large>
      <Modal.Section>
        <Text as="p" variant="bodyMd" tone="subdued">
          This order came from a webshop. Please select which address to use for the delivery note.
        </Text>
      </Modal.Section>
      <Modal.Section>
        <InlineGrid columns={2} gap="400">
          <Card>
            <BlockStack gap="300">
              <Text as="h3" variant="headingMd">
                System Address
              </Text>
              <Text as="p" variant="bodySm" tone="subdued">
                Address from the customer record
              </Text>
              <Box paddingBlockStart="200">
                {defaultAddressParts ? (
                  <BlockStack gap="100">
                    {defaultAddressParts.map((part, i) => (
                      <Text as="p" key={i}>
                        {part}
                      </Text>
                    ))}
                  </BlockStack>
                ) : (
                  <Text as="p" tone="subdued">
                    No address available
                  </Text>
                )}
              </Box>
              <Box paddingBlockStart="400">
                <Button variant="primary" onClick={onSelectDefault} disabled={!defaultAddressParts}>
                  Use system address
                </Button>
              </Box>
            </BlockStack>
          </Card>
          <Card>
            <BlockStack gap="300">
              <Text as="h3" variant="headingMd">
                Webshop Shipping Address
              </Text>
              <Text as="p" variant="bodySm" tone="subdued">
                Address from the external order
              </Text>
              <Box paddingBlockStart="200">
                {externalAddressParts ? (
                  <BlockStack gap="100">
                    {externalAddressParts.map((part, i) => (
                      <Text as="p" key={i}>
                        {part}
                      </Text>
                    ))}
                  </BlockStack>
                ) : (
                  <Text as="p" tone="subdued">
                    No shipping address in external payload
                  </Text>
                )}
              </Box>
              <Box paddingBlockStart="400">
                <Button variant="primary" onClick={onSelectExternal} disabled={!externalAddressParts}>
                  Use webshop address
                </Button>
              </Box>
            </BlockStack>
          </Card>
        </InlineGrid>
      </Modal.Section>
    </Modal>
  );
};
